/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabetical (A→Z)`)
};

const es_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabético (A→Z)`)
};

const de_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabetisch (A→Z)`)
};

const nl_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetisch (A→Z)`)
};

const fr_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabétique (A→Z)`)
};

const it_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetico (A→Z)`)
};

const pt_br2_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabética (A→Z)`)
};

const pt_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabético (A→Z)`)
};

const ja_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アルファベット順 (A→Z)`)
};

const zh_ls_mode_alpha = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字母顺序（A→Z）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_mode_alpha = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_mode_alpha(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_mode_alpha", locale)
	if (locale === "en") return en_ls_mode_alpha(inputs)
	if (locale === "es") return es_ls_mode_alpha(inputs)
	if (locale === "de") return de_ls_mode_alpha(inputs)
	if (locale === "nl") return nl_ls_mode_alpha(inputs)
	if (locale === "fr") return fr_ls_mode_alpha(inputs)
	if (locale === "it") return it_ls_mode_alpha(inputs)
	if (locale === "pt-BR") return pt_br2_ls_mode_alpha(inputs)
	if (locale === "pt") return pt_ls_mode_alpha(inputs)
	if (locale === "ja") return ja_ls_mode_alpha(inputs)
	return zh_ls_mode_alpha(inputs)
};